import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment'
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
  selector: 'app-speedpay-payment',
  templateUrl: './speedpay-payment.component.html',
  styleUrls: ['./speedpay-payment.component.css']
})
export class SpeedpayPaymentComponent implements OnInit {

  @Input() data: any;
  url :any;
  apigeeToken: any;

  onIFrameLoaded($event: any) {
    window.removeEventListener("message", this.onIFrameLoaded, true);
    if($event.data === 'FrameLoaded') {
      let iframe = document.getElementById('my_iframe') as HTMLIFrameElement;
      if(iframe.contentWindow) {
        let str = localStorage.getItem('InvoiceList');
        let obj = str ? JSON.parse(str) : {};
        let billingProps = environment.billingProps;
        //localStorage.getItem("BillingPortalProps")??"{}";
        var azureClientID = billingProps.aud;
        let msalKeys = localStorage.getItem(`msal.token.keys.${azureClientID}`);
        let accessToken = JSON.parse(msalKeys??"{}").accessToken[0];
        var requestData ={
              totalAmounttoPay : localStorage.getItem("totalAmountToPay"),
              invoices : obj,
              ban : obj[0].bpNo,
              BillingPortalProps : billingProps,
              msalKeys : msalKeys,
              azureTokenData: localStorage.getItem(accessToken),
              apigeeToken :this.apigeeToken
            }
            // this.sessStorage.getItem<string>("apigeeToken-bp")
        iframe.contentWindow.postMessage(requestData, environment.serverFURL);
      }
    }
  }

  constructor(private sanitizer: DomSanitizer, private sessStorage: SessionStorageService) { 
   }


   async ngOnInit(): Promise<void> {
    this.apigeeToken = await this.sessStorage.getItem<string>("apigeeToken-bp");
      
    console.log("after Speedpay comp =",this.apigeeToken)
 
    if (window.addEventListener) {
      window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
    }
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.data.ban+"&callbackurl=/invoices/payment-processing");
  
  }

}
